(() => {
  if (customElements.get('zesta-personalisation')) return;
  class ZestaPersonalisation extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.form = this.closest('form');
      this.root = this.closest('[data-zc-product]');
      this.urls = new Map();
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.querySelectorAll('[data-zc-text]').forEach(input => input.addEventListener('input', () => {
        input.setCustomValidity('');
        this.updateSummary();
        this.unconfirm();
      }, options));
      this.querySelectorAll('[data-zc-file]').forEach(input => input.addEventListener('change', () => {
        this.updateFile(input);
        this.unconfirm();
      }, options));
      this.querySelectorAll('[data-zc-remove]').forEach(button => button.addEventListener('click', () => {
        const input = button.closest('.zc-file-field').querySelector('[data-zc-file]');
        input.value = '';
        input.setCustomValidity('');
        this.updateFile(input);
        this.unconfirm();
      }, options));
      this.querySelector('[data-zc-add-photo]')?.addEventListener('click', event => {
        const next = this.querySelector('.zc-extra-upload[hidden]');
        if (!next) return;
        next.hidden = false;
        const input = next.querySelector('input');
        input.disabled = false;
        input.focus();
        if (!this.querySelector('.zc-extra-upload[hidden]')) event.currentTarget.hidden = true;
      }, options);
      this.form?.addEventListener('submit', event => {
        this.querySelectorAll('[data-zc-text]').forEach(input => {
          input.value = input.value.trim();
          input.setCustomValidity(input.required && !input.value ? 'Please enter this personalisation detail.' : '');
        });
        this.querySelectorAll('[data-zc-file]:not(:disabled)').forEach(input => this.validateFile(input));
        if (!this.form.reportValidity()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          const error = this.querySelector('[data-zc-error]');
          error.hidden = false;
          error.textContent = 'Please complete the required details and confirmation before adding to your bag.';
        } else {
          this.querySelector('[data-zc-error]').hidden = true;
        }
      }, { capture: true, signal: this.events.signal });
      this.form?.addEventListener('invalid', () => {
        const error = this.querySelector('[data-zc-error]');
        error.textContent = 'Please complete the required details and confirmation before adding to your bag.';
        error.hidden = false;
      }, { capture: true, signal: this.events.signal });
      if (this.root) {
        this.bar = this.root.querySelector('[data-zc-mobile-bar]');
        if (this.bar) {
          this.bar.hidden = false;
          this.bar.querySelector('[data-zc-mobile-personalise]')?.addEventListener('click', () => {
            this.scrollIntoView({ block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
            this.querySelector('input:not(:disabled),textarea')?.focus({ preventScroll: true });
          }, options);
          const price = this.root.querySelector('[id^="price-"]');
          if (price) {
            this.priceObserver = new MutationObserver(() => this.syncPrice(price));
            this.priceObserver.observe(price, { subtree: true, childList: true, characterData: true });
            this.syncPrice(price);
          }
        }
      }
      this.updateSummary();
    }
    disconnectedCallback() {
      this.events?.abort();
      this.priceObserver?.disconnect();
      this.urls?.forEach(url => URL.revokeObjectURL(url));
      this.ready = false;
    }
    unconfirm() {
      const check = this.querySelector('.zc-confirmation input');
      if (check) check.checked = false;
    }
    validateFile(input) {
      const file = input.files?.[0];
      let message = '';
      if (file) {
        const name = file.name.toLowerCase();
        const raster = /\.(jpe?g|png|webp)$/.test(name);
        const logo = input.hasAttribute('data-zc-logo') && /\.(pdf|svg)$/.test(name);
        if (!raster && !logo) message = 'Choose a supported file format.';
        else if (file.size === 0) message = 'This file is empty. Please select another file.';
        else if (file.size > 10 * 1024 * 1024) message = 'Please choose a file smaller than 10 MB.';
      }
      input.setCustomValidity(message);
      const status = input.closest('.zc-file-field').querySelector('[data-zc-file-status]');
      status.textContent = message || (file ? 'File selected. It will be uploaded when you add this item to your bag.' : '');
      status.classList.toggle('zc-has-error', !!message);
      return !message;
    }
    updateFile(input) {
      const field = input.closest('.zc-file-field');
      const preview = field.querySelector('.zc-file-preview');
      const image = preview.querySelector('img');
      if (this.urls.has(input)) {
        URL.revokeObjectURL(this.urls.get(input));
        this.urls.delete(input);
      }
      image.removeAttribute('src');
      const file = input.files?.[0];
      const valid = this.validateFile(input);
      preview.hidden = !file || !valid;
      if (!file || !valid) return;
      field.querySelector('[data-zc-filename]').textContent = file.name;
      const raster = /\.(jpe?g|png|webp)$/i.test(file.name);
      image.hidden = !raster;
      if (raster) {
        const url = URL.createObjectURL(file);
        this.urls.set(input, url);
        image.src = url;
      }
    }
    updateSummary() {
      const details = this.querySelector('[data-zc-summary]');
      if (!details) return;
      const list = details.querySelector('dl');
      list.replaceChildren();
      this.querySelectorAll('[data-zc-text]').forEach(input => {
        if (!input.value.trim()) return;
        const row = document.createElement('div');
        const dt = document.createElement('dt');
        const dd = document.createElement('dd');
        dt.textContent = input.name.slice(11, -1);
        dd.textContent = input.value.trim();
        row.append(dt, dd);
        list.append(row);
      });
      details.hidden = list.childElementCount === 0;
    }
    syncPrice(container) {
      const price = container.querySelector('.price--on-sale .price-item--sale') || container.querySelector('.price__regular .price-item--regular');
      if (price && this.bar) this.bar.querySelector('[data-zc-mobile-price]').textContent = price.textContent.trim();
    }
  }
  customElements.define('zesta-personalisation', ZestaPersonalisation);
})();
